export enum EventState {
  CANCELLED = 'CANCELLED',
  POSTPONED = 'POSTPONED',
  RESCHEDULED = 'RESCHEDULED',
  UPCOMING = 'UPCOMING',
}



// WEBPACK FOOTER //
// /codebuild/output/src332225586/src/modules/client/src/model/event-state.ts